import styled, { css } from "styled-components";
import { theme } from '../../theme'

function variantButtonStyles({ variant }) {
   switch (variant) {
      case "secondary":
         return css`
            color: ${theme.colors.black};
            background-color: #fff;
            border: 1px solid ${theme.colors.borderColor};

            &:hover,
            &:active {
               opacity: 0.7;
            }

            &:disabled,
            &:disabled:active,
            &:disabled:hover {
               color: ${theme.colors.grey};
               border-color: ${theme.colors.borderColor};
               background-color: ${theme.colors.grey};
               cursor: not-allowed;
            }
         `;
      case "invert":
         return css`
            color: ${theme.colors.white};
            background-color: transparent !important;
            border: 1px solid ${theme.colors.white};

            &:hover,
            &:active {
               opacity: 0.7;
            }

            &:disabled,
            &:disabled:active,
            &:disabled:hover {
               color: ${theme.colors.grey};
               border-color: ${theme.colors.grey};
               background-color: ${theme.colors.grey};
               cursor: not-allowed;
            }
         `;
      case "grey":
         return css`
            color: ${theme.colors.white};
            background-color: #42425f;
            border: 1px solid ${theme.colors.grey};

            &:hover,
            &:active {
               opacity: 0.8;
            }

            &:disabled,
            &:disabled:active,
            &:disabled:hover {
               color: ${theme.colors.grey};
               border-color: ${theme.colors.grey};
               background-color: ${theme.colors.grey};
               cursor: not-allowed;
            }
         `;
      case "link":
         return css`
            color: ${theme.colors.mainBlue};
            background: none;
            font-weight: 500;
            /* padding-left: 0; */

            &:hover,
            &:active {
               opacity: 0.8;
            }

            &:disabled,
            &:disabled:active,
            &:disabled:hover {
               color: ${theme.colors.grey};
               cursor: not-allowed;
            }
         `;
      default:
      case "primary":
         return css`
            color: ${theme.colors.white};
            background-color: ${theme.colors.mainBlue};

            &:hover,
            &:active {
               color: ${theme.colors.white};
               background-color: ${theme.colors.mainBlue};
               opacity: 0.8;
            }

            &:disabled,
            &:disabled:active,
            &:disabled:hover {
               color: ${theme.colors.white};
               border-color: ${theme.colors.grey};
               background-color: ${theme.colors.mainBlue};
               cursor: not-allowed;
               opacity: 0.4;
            }
         `;
   }
}

export const ButtonStyledComponent = styled.button`
font-family: "Quicksand";
   border: 0;
   padding: 0;
   cursor: pointer;
   box-sizing: border-box;
   display: inline-block;
   max-width: 100%;
   text-align: center;
   overflow: hidden;
   white-space: nowrap;
   text-overflow: ellipsis;
   font-size: ${({ size }) => (size === "small" ? "1.2rem" : "1.5rem")};
   letter-spacing: 0;
   line-height: 1.6rem;
   font-weight: bold;
   border-radius: .4rem;
   text-transform: uppercase;
   transition: all 300ms ease-in-out;
   background-color: ${theme.colors.mainBlue};
   color: ${theme.colors.white};
   display: flex;
   justify-content: center;
   align-items: center;
   padding: ${({ size }) => {
      switch (size) {
         case "small":
            return "1rem 2rem;";
         default:
            return "1.3rem 2.9rem;";
      }
   }};

   ${({ fullWidth }) =>
      fullWidth &&
      css`
         width: 100%;
      `};
      ${({ responsive }) =>
      responsive &&
      css`
        @media only screen and (max-width: 468px) {
            width: 100%;
            margin-bottom: 20px;
            margin-left: 0px !important;
        }
      `};
    

   ${variantButtonStyles}
`;
